module.exports = __webpack_public_path__ + "static/media/home-icon.4ed9d344.svg";